export default {
    info: 'Profile Information',
    email: 'Email',
    password: 'Password',
    address: 'Address',
    phone: 'Phone',
    changePs: 'Change your password',
    transRecord: 'Transaction Record',
    noTransYet: 'No transaction yet',
    logout: 'Log Out',
    age: 'Age',
    date: 'Date',
    orderContent: 'Order Content',
    orderNumber: 'Order Number',
    orderPrice: 'Order Price',
    action: 'Action',
    title: 'Are you sure you want to log out?',
    cancel: 'Cancel',
    ok: 'OK',
    update: 'Update success',
    typeError: 'file type error',
    sizeError: 'file size error',
    editImg: 'Edit Image',
    editInfo: 'Edit Information',
    editEmail: 'Edit Email',
    editAddress: 'Edit Address',
    resetPwd: 'Reset Password',
    phoneInfo: 'Check your phone for message with a verification code',
    confirm: 'Confirm',
    successMsg: 'New password updated successfully!',
    successMsg1: 'Please sign in again.',
    reEnterPwd: 'Re-enter password',
    change: 'Change',
    subOrder: 'Sub-order',
    pay: 'Pay Now',
    preview: 'Preview',
		sentEmail: 'The authorization code has been sent to {email}. Please check your email.',
		codeTxt: 'Code',
		emailErr: 'You must enter a valid email address',
}
